import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {MerchantButton} from "../../../../common/MerchantButton";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";
import {Toast} from "../../../../ui/Toast.jsx";


@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardSubscribeChangeSuccessPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.subscribeChangeSuccess,
        }
    }

    render() {
        return [
            <MessageElement message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())}/>,
            <MerchantButton label={Messages.ok} className={this.styleSheet.actionButton}
                            onClick={() => {
                                Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
                                Toast.showSuccess(Messages.changesSaved);
                            }}/>,
        ];
    }
}
